import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Header2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { getNonWorkingUserIdsByDate } from "~/store/selectors/selector.calendars";
import { getUsersByIds } from "~/store/selectors/selector.users";
import UserLink from "../../UserLink/UserLink";

export const CalendarUnavailablePeople = ({ date }) => {
  const { t } = useTranslation();
  const userIds = useSelector((state) => getNonWorkingUserIdsByDate(state, date));
  const users = useSelector((state) => getUsersByIds(state, userIds));

  const unavailableUsers = useMemo(() => {
    if (users) {
      return Object.values(users.toJS())
        .sort((a, b) => a.display_name.localeCompare(b.display_name))
        .map((user) => user.id);
    }
    return [];
  }, [users]);

  if (userIds.length === 0) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-flex tw-items-center tw-h-10">
        <Header2>{t("Unavailable People")}</Header2>
      </div>
      <div className="tw-flex tw-flex-col">
        {unavailableUsers.map((id, index) => {
          return (
            <UserLink
              id={id}
              key={index}
              className="tw-h-6 tw-ml-1 tw-w-fit tw-my-2"
              context="calendar unavailable people"
            />
          );
        })}
      </div>
    </div>
  );
};
CalendarUnavailablePeople.propTypes = {
  date: PropTypes.string,
};
